import * as d3Array from 'd3-array'
import * as d3Scale from 'd3-scale'
import * as d3ScaleChromatic from 'd3-scale-chromatic'
// import queryString from 'query-string'

// const hexRegEx = /([0-9]|[a-f])/gim
// const isHex = input => typeof input === 'string' && (input.match(hexRegEx) || []).length === input.length

export const GREENS = d3ScaleChromatic.interpolateGreens
export const REDS = d3ScaleChromatic.interpolateReds

export const DEFAULT_RANGE = d3Array.range(0, 1, 0.25)
// const anyColorChange = /rise|loss|neutral/gi
const riseColorsArray = []
const lossColorsArray = []
const neutralColor = '#bcb2b1'
export const defaultGreens = [neutralColor, '#7ec17e', '#518651', '#215e2c']
export const defaultReds = [neutralColor, '#ed7171', '#c84040', '#aa2121']

// if (anyColorChange.test(location.search)) {
//   try {
//     const parsedQS = queryString.parse(location.search)

//     Object.entries(parsedQS).map(([key, value]) => {
//       const safeValue = value.split(',').slice(0, 3)

//       if (key === 'rise' || key === 'loss') {
//         const colorsArr = { rise: riseColorsArray, loss: lossColorsArray }[key]
//         const defaultColorsArr = { rise: defaultGreens, loss: defaultReds }[key]

//         safeValue.filter(isHex).forEach(color => {
//           colorsArr.push(`#${encodeURI(color)}`)
//         })

//         if (colorsArr.length < 3) {
//           defaultColorsArr.slice(defaultColorsArr.length + 1 - colorsArr.length).forEach(color => {
//             colorsArr.push(color)
//           })
//         }
//       } else if (key === 'neutral') {
//         if (isHex(safeValue[0])) {
//           neutralColor = `#${encodeURI(safeValue[0])}`
//         }
//       }
//     })
//   } catch (error) {
//     /* eslint-disable no-console */
//     console.error(error)
//     console.error('The error above happened while trying to get colors from query string')
//     /* eslint-enable no-console */
//   }
// }

export const GREENS_LIST = [
  neutralColor,
  ...(riseColorsArray.length > 0 ? riseColorsArray : defaultGreens.slice(1)),
]

export const GREENS_SCALE = d3Scale
  .scaleThreshold()
  .domain(DEFAULT_RANGE)
  .range(GREENS_LIST)

export const REDS_LIST = [
  neutralColor,
  ...(lossColorsArray.length > 0 ? lossColorsArray : defaultReds.slice(1)),
]

export const REDS_SCALE = d3Scale
  .scaleThreshold()
  .domain(DEFAULT_RANGE)
  .range(REDS_LIST)

export const ZERO_COLOR = neutralColor

export default class Colors {
  createScale = () => {
    const minValueScale = d3Scale
      .scaleThreshold()
      .domain([5, 15, 25, 100])
      .range(DEFAULT_RANGE)
    const maxValueScale = d3Scale
      .scaleThreshold()
      .domain([5, 15, 25, 100])
      .range(DEFAULT_RANGE)

    return v => {
      if (v > 0) {
        return GREENS_SCALE(maxValueScale(v))
      } else if (v < 0) {
        return REDS_SCALE(minValueScale(Math.abs(v)))
      } else {
        return ZERO_COLOR
      }
    }
  }
}
